<template>
    <b-form-select-option-group
        :disabled-field="disabledField"
        :label="label"
        :options="options"
        :text-field="textField"
        :value-field="valueField"
    >
        <slot name="first" slot="first" />
        <slot />
    </b-form-select-option-group>
</template>

<script>
import { BFormSelectOptionGroup } from 'bootstrap-vue'

export default {
    components: { BFormSelectOptionGroup },
    props: {
        disabledField: { type: String, default: 'disabled' },
        label: { type: String, required: true },
        options: { type: [Array, Object] },
        textField: { type: String, default: 'nome' },
        valueField: { type: String, default: 'id' },
    }
}
</script>